import { render } from "./MattersArisingFilter.vue?vue&type=template&id=3cf85a7a"
import script from "./MattersArisingFilter.vue?vue&type=script&lang=js"
export * from "./MattersArisingFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__